// Values must match the backend AppointmentNotificationChannel enum (persisted ints).
export enum AppointmentNotificationChannel {
  Email = 0,
  Sms = 1,
  Unknown = -1
}
